"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MbAuthenticator = void 0;
const framework_1 = require("../../../framework");
const timeOut_helper_1 = require("../../../features/timeOut/helpers/timeOut.helper");
//TODO Authenticator only for model or not??
class MbAuthenticator extends framework_1.BaseAuthenticator {
    constructor(session, xhr, getDeviceUUID, urlConfig) {
        super(session);
        this.doLogin = (data) => __awaiter(this, void 0, void 0, function* () {
            const deviceUUID = yield this.getDeviceUUID();
            const os = yield this.getOperatingSystem();
            const LoginInfo = Object.assign(Object.assign({ username: data.username, documentType: data.documentType, password: data.password, passwordPosition: data.passwordPosition }, (data.customerSessionId ? { customerSessionId: data.customerSessionId } : {})), { deviceInformation: {
                    deviceUUID,
                    webDeviceInfo: {
                        version: os,
                    },
                } });
            const response = yield this.xhr.POST(this.urlConfig.login, LoginInfo, {
                headers: Object.assign({}, (data.progressId ? { progressId: data.progressId } : undefined)),
            });
            const { accessToken, refreshToken, expiresIn, sessionExpiresAt } = response.data;
            const convertedData = {
                accessToken,
                refreshToken,
                expiresIn,
                sessionExpiresAt: sessionExpiresAt ? new Date(sessionExpiresAt) : null,
                timeOutStamp: (0, timeOut_helper_1.getTimeOutStamp)(expiresIn),
                customerSessionId: data.customerSessionId,
            };
            const redirectTo = (response.responseHeaders['x-security'] || response.responseHeaders['location'] || null);
            return Object.assign(Object.assign({}, convertedData), { username: data.username, redirectTo });
        });
        this.doLogout = () => __awaiter(this, void 0, void 0, function* () {
            var _a;
            const accessToken = (_a = this.getSession().getData()) === null || _a === void 0 ? void 0 : _a.accessToken;
            yield this.xhr.POST(this.urlConfig.logout, { accessToken });
        });
        this.getPasswordPositions = (username, documentType) => __awaiter(this, void 0, void 0, function* () {
            const PasswordPositionInfo = {
                username,
                documentType,
            };
            const response = yield this.xhr.POST(this.urlConfig.getPasswordPositions, PasswordPositionInfo);
            return response.data;
        });
        this.getDocumentFormats = () => __awaiter(this, void 0, void 0, function* () {
            const response = yield this.xhr.GET(this.urlConfig.documentFormats);
            return response.data;
        });
        this.validateDocumentFormat = (documentType, documentValue) => __awaiter(this, void 0, void 0, function* () {
            const DocumentTypeInfo = {
                documentType,
                documentValue,
            };
            const response = yield this.xhr.POST(this.urlConfig.validateDocumentFormat, DocumentTypeInfo);
            return response.data;
        });
        this.xhr = xhr;
        this.getDeviceUUID = getDeviceUUID;
        this.urlConfig = urlConfig;
    }
    getOperatingSystem() {
        return __awaiter(this, void 0, void 0, function* () {
            const WIN_11_PLATFORM_VERSION = 13;
            if (navigator.userAgentData) {
                const { platform, platformVersion } = yield navigator.userAgentData.getHighEntropyValues(['platform', 'platformVersion']);
                const majorVersion = parseInt(platformVersion.split('.')[0], 10);
                if (platform === 'Windows' && majorVersion >= WIN_11_PLATFORM_VERSION) {
                    return navigator.userAgent.replace('Windows NT 10.0', 'Windows NT 11.0');
                }
            }
            return navigator.userAgent;
        });
    }
}
exports.MbAuthenticator = MbAuthenticator;
//# sourceMappingURL=MbAuthenticator.js.map